module.exports = __webpack_public_path__ + "img/12.e8b39a59.jpg";